window.addEventListener("DOMContentLoaded", function () {
    const currentTakeover = document.querySelector('[data-takeover="exit-intent"]');

    if (currentTakeover) {
        const currentTakeoverOverlay = document.querySelector('[data-takeover-overlay="exit-intent"]');
        const sessionData = sessionStorage.getItem('merlinExitIntent');
        const showTo = currentTakeover.getAttribute('data-show-to');

        //Events for Close Modal and Toggle Modal Content
        document.addEventListener("click", function (e) {
            //Remove the takeover from the DOM

            if (e.target.getAttribute('data-takeover-close') === 'exit-intent' || e.target.getAttribute('data-takeover-close') === 'modal') {
                if(e.target.closest('[data-takeover="exit-intent"]')) {
                    if (currentTakeoverOverlay) {
                        //Hack to prevent scrolling of body when modal is open pt2
                        const scrollY = document.body.style.top;
                        document.body.style.position = '';
                        document.body.style.top = '';
                        document.body.style.left = '';
                        document.body.style.right = '';
                        window.scrollTo({top: parseInt(scrollY || '0') * -1, left: 0, behavior: 'instant'});
                    }

                    if (currentTakeoverOverlay != undefined) {
                        currentTakeoverOverlay.remove();
                    }

                    currentTakeover.remove();
                }
            }
        });

        //Show overlay on exit intent if session data is not set
       if(sessionData == null){
            if (window.innerWidth <= 768) {
                if(showTo !== 'DesktopOnly') {
                    exitIntentScroll();
                }
            } else {
                if(showTo !== 'MobileOnly') {
                    exitIntentMouse();
                }
            }
        }

        //Show overlay
        function showTakeover() {
            //Check if modal takeover is already open
            const takeoverModal = document.querySelector('[data-takeover="modal"].CenteredTakeover');

            if(takeoverModal?.classList.contains('isActive')) {
                takeoverModal.querySelector('[data-takeover-close="modal"]')?.click();

                //Reapply hack
                document.body.style.top = `-${window.scrollY}px`;
                document.body.style.position = 'fixed';
                document.body.style.left = '0px';
                document.body.style.right = '0px';
            }

            currentTakeover.classList.add('isActive');

            if (currentTakeoverOverlay) {
                currentTakeoverOverlay.classList.add('isActive');
            }   

            //Hack to prevent scrolling of body when modal is open pt1 - https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
            document.body.style.top = `-${window.scrollY}px`;
            document.body.style.position = 'fixed';
            document.body.style.left = '0px';
            document.body.style.right = '0px';
            
            currentTakeover.focus();

            sessionStorage.setItem('merlinExitIntent', 'true');
        }

        //Show overlay on exit intent with mouse movement
        function exitIntentMouse() {
            const body = document.querySelector('body');
            let mouseY;
            
            const handleMouseleave = (event) => {
              mouseY = event.clientY;

              if (mouseY < 0) {
                showTakeover();
                body.removeEventListener('mouseleave', handleMouseleave);
              }
            };
            
            body.addEventListener('mouseleave', handleMouseleave);
        }

        function exitIntentScroll() {
            let lastPosition = 0;
            let newPosition = 0;
            let timer;
            const delay = 50;

            function clear() {
                lastPosition = null;
            }

            const checkScrollSpeed = () => {
                newPosition = window.scrollY;
                
                if (lastPosition !== null) {
                    const delta = newPosition - lastPosition;
                    if (delta < -80) { // Adjust this threshold as needed
                        showTakeover();
                        window.removeEventListener('scroll', checkScrollSpeed);
                    }
                }

                lastPosition = newPosition;
                clearTimeout(timer);
                timer = setTimeout(clear, delay);
            }

            window.addEventListener('scroll', checkScrollSpeed);
        }
    }
});